import { createFileRoute } from '@tanstack/react-router';
import { TransactionCategoriesPage } from '@/features/accounting/parameters/transaction-categories/components/TransactionCategoriesPage';

export const Route = createFileRoute(
  '/$commiteeSlug/accounting/parameters/transaction-categories/{-$id}'
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <TransactionCategoriesPage />;
}
